import { Card, CardProps, Group, Loader, Text } from '@mantine/core';
import classes from './StatCard.module.css';
import { ReactNode } from 'react';

type props = CardProps & {
  title: string;
  value?: string | number | null;
  active?: boolean;
  onClick?: () => void;
  icon?: ReactNode;
  bg?: string;
};

const StatCard = ({ title, value, active = false, onClick, icon, bg = 'transparent' }: props) => {
  return (
    <Card
      padding="xs"
      radius="10px"
      // withBorder
      className={classes.card}
      data-active={active}
      bg={bg}
      w={'100%'}
      onClick={onClick}
    >
      <Group justify={'space-between'} wrap={'nowrap'} mb={'md'}>
        {value === undefined && <Loader size="sm" />}
        {value !== undefined && (
          <Text size="17px" fw={600} style={{ color: active ? 'var(--velos-brand-blue)' : '#6B7280' }}>
            {value}
          </Text>
        )}
        {icon}
      </Group>

      <Text fw={400} size={'14px'} style={{ color: active ? 'var(--velos-brand-blue)' : '#6B7280' }}>
        {title}
      </Text>
    </Card>
  );
};

export default StatCard;
